import { useEffect, useRef, useState } from 'react'

import classNames from 'classnames'

import Container from '~/components/atoms/Container/Container'
import { Icon } from '~/components/atoms/Icon/Icon'
import Text from '~/components/atoms/Text/Text'

import styles from './MagazineHero.module.css'

export interface MagazineHeroProps {
  testID?: string
}

export default function MagazineHero({ testID }: MagazineHeroProps) {
  const logoRef = useRef<HTMLDivElement>(null)
  const subTitle = useRef<HTMLDivElement>(null)
  const mainContainerRef = useRef<HTMLDivElement>(null)
  const [padding, setPadding] = useState<number>(0)
  const [isFixed, setIsFixed] = useState<boolean>(false)

  useEffect(() => {
    const setPaddingAndFix = () => {
      const logoHeight = logoRef.current?.clientHeight

      if (logoHeight && logoHeight > 0) {
        setPadding(logoHeight)
        setIsFixed(true)
      }
    }

    const fadeSubtitle = () => {
      if (!subTitle?.current || !mainContainerRef.current) return

      const wrapHeight = mainContainerRef.current?.clientHeight
      const scrollY = window.scrollY

      const percentage = 1 - scrollY / wrapHeight
      subTitle.current.style.opacity = `${percentage}`
    }

    // Get height of the logo
    setPaddingAndFix()

    window.addEventListener('resize', setPaddingAndFix)
    window.addEventListener('scroll', fadeSubtitle)

    return () => {
      window.removeEventListener('resize', setPaddingAndFix)
    }
  }, [logoRef.current?.clientHeight])

  return (
    <div className={styles.base} data-testid={testID} ref={mainContainerRef}>
      <div style={{ paddingBottom: `${padding}px` }}>
        <div
          className={classNames(styles.title, isFixed && styles.fixed)}
          ref={logoRef}
        >
          <Container>
            <Icon type="EditionLogo" responsive />
          </Container>
        </div>
      </div>
      <Container>
        <Text Tag="h3" className={styles.subtitle} weight="bold">
          <span ref={subTitle}>The Print Market Magazine</span>
        </Text>
      </Container>
    </div>
  )
}
